import { useEffect } from "react";

const SubsidiaryChoiceRedirect = () => {
  useEffect(() => {
    window.location.href = "/";
  }, []);

  return null;
};

export default SubsidiaryChoiceRedirect;
